import {Component} from '@angular/core';

/* Body only -- HelpDialogComponent supplies the dialog chrome and Okay button. */
@Component({
    selector: 'app-group-sales-help',
    templateUrl: './group-sales-help.component.html'
})
export class GroupSalesHelpComponent {
}
